// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2EXv2","content":"styles_content__35O6f","checkbox":"styles_checkbox__19kCl","checkboxLabel":"styles_checkboxLabel__1C-tH"};